/// <reference lib="dom" />
import { authProvider } from '@onevision-resources/login';
import { Auth } from 'aws-amplify';
import { createRoot } from 'react-dom/client';
import { config } from 'src/core/config';
import App from './App';

authProvider.setup({
  cognitoClientId: config.cognitoClientId,
  cognitoUserPoolId: config.cognitoUserPoolId,
  cognitoUserPoolRegion: config.cognitoUserPoolRegion,
  env: config.env,
});

// TODO: move this to '@onevision-resources/login' package
// TODO: it should explicitly check isolated env.
// Only an isolated deployment sets this: it points sign-in at the local emulator's Cognito.
// `@onevision-resources/login` does not expose the option, but `Auth.configure` merges into the
// configuration `setup` just applied, so only the endpoint changes. `aws-amplify` is pinned to the
// version the login package resolves, so both talk to the same `Auth` singleton.
if (config.cognitoEndpoint) {
  Auth.configure({ endpoint: config.cognitoEndpoint });
}

createRoot(document.getElementById('app')!).render(<App />);
